<template>
    <div :class="['relative', (isMobile || isBig) ? 'p-[2rem] pt-[3.5rem]' : 'p-[8rem] pt-[4rem]']">
      <div class="header flex justify-between items-center mb-6">
        <div :class="['absolute', isMobile ? 'top-5 right-0 z-10' : 'top-8 right-8 z-10']">
          <div 
            class="bg-white custom-border text-blue-700 px-4 py-1 rounded-full flex items-center shadow-md cursor-pointer"
            @click="toggleLanguageDropdown"
          >
            <img :src="currentFlag" alt="Langue" class="w-8 h-8 mr-2" />
            <i class="fas fa-chevron-down"></i>
          </div>
  
          <div 
            v-if="showLanguageDropdown" 
            class="absolute right-0 mt-2 bg-white shadow-lg rounded-lg p-2 w-32"
          >
            <button
              @click="setLanguage('fr')"
              class="flex items-center justify-start w-full px-2 py-1 hover:bg-blue-100 rounded-md transition"
            >
              <img src="../../assets/france-flag.png" alt="Français" class="w-6 h-6 mr-2" />
              Français
            </button>
            <button
              @click="setLanguage('en')"
              class="flex items-center justify-start w-full px-2 py-1 hover:bg-blue-100 rounded-md transition"
            >
              <img src="../../assets/uk-flag.png" alt="English" class="w-6 h-6 mr-2" />
              English
            </button>
          </div>
        </div>
      </div>
  
      <div class="immediate-section mt-[3rem] relative">
        <h3 class="next-step mb-7">  {{this.$t('checkout.commandTitle', { name: name_client })}}</h3>
        <div class="list-note">{{ $t('checkout.commandRecap') }}</div>
        <p class="list-note mt-3">
          {{ $t('checkout.commandForgotten') }}
          <a href="#" @click.prevent="reconfirmSubscription" class="reconfirm-link">{{ $t('checkout.commandForgottenV2') }}</a>.
        </p>
        
        <div class="immediate-section-background mt-7">
            <div class="grid grid-cols-1 gap-6 rounded-md">
                <div class="pt-4 rounded-md">
                    <template v-if="paymentData && Array.isArray(paymentData.paymentData)">
                    <div 
                        v-for="(item, index) in paymentData.paymentData" 
                        :key="index" 
                        class="mb-6 border-b border-gray-200 pb-3 last:border-0"
                    >
                        <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center space-x-4">
                            <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
                            {{ item.quantity }}
                            </span>
                            <h2 class="text-profil">
                            {{ item.type === 'european' 
                                ? $t('checkout.europeanProfile') 
                                : $t('checkout.americanProfile')
                            }}
                            </h2>
                            
                        </div>
                        <span v-if="isSummaryLoading" class="loading-animation"></span>
                        <div v-else class="flex justify-end items-center space-x-4">
                        <span class="priceTotalMonths">
                            <span class="priceTotalMonthsPerProfiles">{{item.unitPrice + getCurrencySymbol()}}</span>{{ $t('checkout.pricePerMonth2') }}/{{ $t('checkout.profil') }} 
                        </span>
                        <span class="TotalMonthsPerProfiles text-right relative">
                            
                            <span class="priceTotalMonthsPerProfiles">
                                {{ $t('checkout.pricePerMonth1') }} {{item.totalPrice + getCurrencySymbol()}}
                            </span>{{ $t('checkout.pricePerMonth2') }}
                        </span>
                        </div>

                    </div>

                <ul class="space-y-2" v-if="item.type === 'european'">
                <li class="flex items-center">
                    <svg  class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.europeProfile') }} <span class="font-bold">{{ $t('checkout.europeProfile2') }}</span>
                    </span>
                    </li>
                    <li class="flex items-center">
                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.europeIp') }} <span class="font-bold">{{ $t('checkout.europeIp2') }}</span>
                    </span>
                    </li>
                    <li class="flex items-center">
                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.warmup') }}
                    </span>
                    </li>
                    <li class="flex items-center">
                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.replacement') }}
                    </span>
                    </li>
                </ul>

                <ul class="space-y-2" v-if="item.type === 'american'">
                    <li class="flex items-center">

                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.usProfile') }} <span class="font-bold">{{ $t('checkout.usProfile2') }}</span> {{ $t('checkout.usProfile3') }}
                    </span>
                    </li>
                    <li class="flex items-center">
                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.usIp') }} <span class="font-bold">{{ $t('checkout.usIp2') }}</span> {{ $t('checkout.usIp3') }}
                    </span>
                    </li>
                    <li class="flex items-center">
                        <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.warmup') }}
                    </span>
                    </li>
                    <li class="flex items-center">
                    <svg class="responsive-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 13 13" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79232 1.08301C3.07402 1.08301 2.38515 1.36835 1.87724 1.87626C1.36933 2.38417 1.08398 3.07305 1.08398 3.79134V9.20801C1.08398 9.9263 1.36933 10.6152 1.87724 11.1231C2.38515 11.631 3.07402 11.9163 3.79232 11.9163H9.20898C9.92728 11.9163 10.6162 11.631 11.1241 11.1231C11.632 10.6152 11.9173 9.9263 11.9173 9.20801V3.79134C11.9173 3.07305 11.632 2.38417 11.1241 1.87626C10.6162 1.36835 9.92728 1.08301 9.20898 1.08301H3.79232ZM8.52107 5.78684C8.56972 5.73491 8.60767 5.67391 8.63275 5.60732C8.65783 5.54073 8.66955 5.46984 8.66724 5.39872C8.66492 5.3276 8.64862 5.25763 8.61927 5.19281C8.58991 5.12799 8.54808 5.06958 8.49615 5.02092C8.44422 4.97227 8.38322 4.93432 8.31663 4.90924C8.25003 4.88416 8.17915 4.87244 8.10803 4.87476C8.03691 4.87707 7.96694 4.89337 7.90212 4.92272C7.83729 4.95208 7.77889 4.99391 7.73023 5.04584L6.06028 6.82792L5.23532 6.09505C5.12723 6.0052 4.98845 5.96088 4.8483 5.97145C4.70814 5.98203 4.57758 6.04667 4.4842 6.15172C4.39082 6.25677 4.34193 6.39401 4.34786 6.53444C4.35379 6.67487 4.41408 6.80749 4.51598 6.9043L5.73473 7.98763C5.84019 8.08131 5.97803 8.13015 6.11893 8.12378C6.25984 8.1174 6.39271 8.05632 6.48928 7.95351L8.52107 5.78684Z" fill="#4CAF50"/>
                    </svg>
                    <span class="text-sm-payment ml-4">
                        {{ $t('checkout.replacement') }}
                    </span>
                    </li>
                </ul>

                </div>
                </template>

            </div>
        

            <div v-if="paymentData && paymentData.paymentDataWithAddons.addons && paymentData.paymentDataWithAddons.addons.length > 0">
                
                <div class="recurring-section">
                    <h3 class="text-profil-white mb-3">Add-ons</h3>
                    <div
                    v-for="addon in paymentData.paymentDataWithAddons.addons"
                    :key="addon.id"
                    class="flex items-center justify-between border-b border-gray-200 py-3 last:border-0"
                    >
                    <img
                        :src="addontable[addon.name]"
                        alt="Logo"
                        :class="addon.name === 'HeyReach Business' ? 'h-6 filter' : 'h-8 filter'"
                      />
                    <span v-if="isSummaryLoading" class="loading-animation"></span>
                    <div v-if="!isSummaryLoading && addon.name !== 'HeyReach Business' && addon.name !== 'Get Sales.io'" class="flex justify-end items-center space-x-4">
                        <span class="priceTotalMonths-white">
                            <span class="priceTotalMonthsPerProfiles">{{ addon.price + getCurrencySymbol() }}</span>{{ $t('checkout.pricePerMonth2') }} 
                        </span>
                        <span class="TotalMonthsPerProfiles text-right">
                        <span class="priceTotalMonthsPerProfiles">
                            {{ $t('checkout.pricePerMonth1') }} {{ addon.totalPrice + getCurrencySymbol() }}{{ $t('checkout.pricePerMonth2') }}
                        </span>
                        
                        </span>
                    </div>
                    </div>
                </div>
                <div class="flex items-center justify-between  p-2 last:border-0 mt-3"
                >   
                    <div class="flex items-center gap-4 total-profil">
                        Total
                    </div>
                    <div  class="flex justify-end items-center space-x-4 total-panier">
                        <span class="priceTotalMonthsPerProfiles">{{ totalPrice() + getCurrencySymbol() }}</span>{{ $t('checkout.pricePerMonth2') }}
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="flex justify-center gap-4 mt-8 w-full">
          <button class="visit-faq px-8 py-3 rounded-full" @click="redirectToCheckout">
            {{ $t('checkout.validcommand') }} 
          </button>

          <button class="button-continu px-8 py-3 rounded-full" @click="redirectToPurchase">
            {{ $t('checkout.modifycommand') }}
          </button>
        </div>
      </div>
      <button
        @click="reconfirmSubscription" 
        :class="[
            'ml-auto replace-button border px-8 py-3 rounded-full text-sm font-semibold flex items-center justify-center transition-colors mt-5'
          ]"
      ><span 
        class="inline-block overflow-hidden transition-all"
      >
        {{ $t('checkout.decoButton')}}
      </span></button>
    </div>
    <div 
      v-if="showToast" 
      class="fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 text-white font-semibold rounded-lg shadow-lg transition-opacity duration-300 bg-green-500"
      style="z-index: 9999;"
    >
      {{ toastMessage }}
    </div>
  
  </template>
  
  <script>
  import franceFlag from '../../assets/france-flag.png';
  import ukFlag from '../../assets/uk-flag.png';
  import heyreach from '../../assets/heyreach-logo-white.png'
  import mirrorchat from '../../assets/mirrorchat-logo-white.png'
  import getSales from '../../assets/getSales-logo-white.png'
  import custom from '../../assets/custom-Logo.png'
  import salesNav from '../../assets/SalesNav-logo-white.png'
  import axios from '../../plugins/axios';
  
  
  export default {
    name: 'panierView',
    data() {
    return {
      flags: {
        fr: franceFlag,
        en: ukFlag,
      },
      isBig: false,
      currentLanguage: localStorage.getItem('langue') || navigator.language,
      showLanguageDropdown: false,
      isMobile: false,
      maleCount: 0, 
      femaleCount: 0, 
      totalCount: localStorage.getItem('numberAccount') || 0,
      showToast: false,
      toastMessage: '',
      isSubmitting: false,
      paymentData: null,
      name_client: "",
      addontable: {
        "HeyReach Business": heyreach,
        "MirrorChat": mirrorchat,
        "Custom Branding": custom,
        "Get Sales.io": getSales,
        "Sales Navigator": salesNav,
      },
      summaryData: {
        immediate: {
          subtotal: '0.00',
          vat: '0.00',
          total: '0.00',
          currency: 'eur',
          items: [],
        },
        recurring: {
          subtotal: '0.00',
          vat: '0.00',
          total: '0.00',
          currency: 'eur',
          items: [],
        },
      },
    };
  },
  computed: {
    currentFlag() {
      const languageKey = this.currentLanguage.split('-')[0];
      return this.flags[languageKey] || this.flags.en;
    },
    
  },
  methods: {
    reconfirmSubscription() {
      localStorage.removeItem('token_checkout');
      this.$router.push('/subscribe/v3'); 
    },
    redirectToCheckout() {
      localStorage.setItem('returncheckout', true);
      localStorage.removeItem('subscriptwithoutpay');
      this.$router.push('/subscribe/v1'); 
    },
    async redirectToPurchase() {
      try {
        this.isLoading = true;
        const email = localStorage.getItem('email_checkout');
        localStorage.setItem('subscriptwithoutpay', true);

        const response = await axios.post('/api/offline-checkout-email', {
          email,
          paymentData: this.paymentData,
        });
        const { url } = response.data;
        window.location.href = url;
      } catch (error) {
        console.error("Erreur lors de la requête offline-checkout :", error);
        alert("Erreur interne ou réseau.");
      }finally {
        this.isLoading = false;
      }

    },
    handleCheckoutLogout() {
      localStorage.removeItem('subscriptwithoutpay');
      this.$router.push('/subscribe/v1');
    },
    isBannedAddon(addonName) {
      const bannedAddons = ["HeyReach Business", "Get Sales.io"];
      return bannedAddons.includes(addonName);
    },

    totalPrice() {
      let total = 0;

      if (this.paymentData && this.paymentData.paymentData) {
          total += this.paymentData.paymentData.reduce((sum, item) => sum + item.totalPrice, 0);
      }

      if (this.paymentData && this.paymentData.paymentDataWithAddons && this.paymentData.paymentDataWithAddons.addons) {
          total += this.paymentData.paymentDataWithAddons.addons
              .filter(addon => !this.isBannedAddon(addon.name)) 
              .reduce((sum, addon) => sum + addon.totalPrice, 0);
      }

      return total.toFixed(2);
    },
    getCurrencySymbol() {
        const currencyCode = this.paymentData?.currency || 'EUR';

        const currencyToSymbol = {
        EUR: '€',
        USD: '$',
        GBP: '£',
        CAD: '$',
        };

        return currencyToSymbol[currencyCode] || currencyCode;
    },


    showToastMessage(title, message) {
      this.toastMessage = `${title} ${message}`;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
        this.toastMessage = '';
      }, 3000);
    },
    updateIsMobile() {
        this.isMobile = window.innerWidth <= 768; 
        this.isBig = window.innerWidth <= 1700;
      },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    setLanguage(lang) {
      this.currentLanguage = lang;
      this.$i18n.locale = lang;
      this.showLanguageDropdown = false;
      localStorage.setItem('langue', lang)
      localStorage.setItem('lang', lang);
    },
    
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    const storedPaymentData = localStorage.getItem('paymentDataFull');
    if (storedPaymentData) {
      const data = JSON.parse(storedPaymentData);
      this.paymentData = data;
    }
    this.name_client = localStorage.getItem('name');
    if (!this.paymentData) {
      console.error('Aucune donnée de paiement trouvée.');
      const currentStep = 1;

      localStorage.setItem('currentStep', currentStep);

      const stepEvent = new StorageEvent('storage', {
        key: 'currentStep',
        newValue: currentStep.toString(),
      });

      window.dispatchEvent(stepEvent);
      this.$router.push('/subscribe/v1');
      return;
    }
    },
  };
  </script>
  
  <style scoped>
  .immediate-section{
  border-radius: 10px;
  padding: 3rem;
  background: #fff;
  box-shadow: 0px 20px 40px rgba(30, 147, 253, 0.2);
  }

  .immediate-section-background{
    border-radius: 10px;
    padding: 3rem;
    background: #F4F4F4;
  }
  
  .recurring-section {
  color:#fff;
  border-radius: 20px;
  padding: 2rem;
  background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
  box-shadow: 0px 20px 40px rgba(30, 147, 253, 0.2);
  }
  
  .text-success{
  border-radius: 5px;
  background: #D2EAFF;
  color: #1A1A1A;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  }
  
  .text-details-success{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; 
  }
  
  .next-step{
  color: #000;
  font-family: Montserrat;
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; 
  }
  
  .list-note{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; 
  }
  
  .text-help{
  color: #FFF;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-items: center;
  }
  
  .visit-faq {
    border: 2px solid #1E93FD;
    background: #FFF;
    color: #1E93FD;
    transition: all 0.3s ease;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
  
  .visit-faq span {
    background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; 
  }
  
  .visit-faq:hover {
    background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
    color: #FFF;
    border-color: transparent;
    box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
  }
  
  .visit-faq:hover span {
  -webkit-text-fill-color:#FFF; 
  }
  
  .contact-us{
  border-radius: 50px;
  font-weight: bold; 
  text-align: center; 
  font-size: 16px;
  border: 2px solid #FFF;
  }
  
  .contact-us span{
  -webkit-text-fill-color:#FFF; 
  }
  
  
  .contact-us:hover {
  background: #FFF;
  color: #1E93FD;
  border: 2px solid #1E93FD;
  }
  
  
  .contact-us:hover span {
  background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; 
  }
  
  
  
  .key-success{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; 
  }
  
  .text-waiting{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; 
  }
  
  .button-our-guides{
  border-radius: 50px;
  background: linear-gradient(90deg, #1E93FD 0%, #3153C7 100%);
  color: #FFF;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  transition: all 0.3s ease-in-out; 
  }
  
  .button-our-guides:hover {
  background: linear-gradient(90deg, #3153C7 0%, #1E93FD 100%);
  transform: scale(1.05); 
  box-shadow: 0px 4px 10px rgba(30, 147, 253, 0.4); 
  }
  
  .button-our-guides:disabled {
  background: linear-gradient(90deg, #cccccc 0%, #999999 100%);
  color: #666666;
  cursor: not-allowed;
  transform: none; 
  box-shadow: none;
  opacity: 0.6;
  }
  
  .button-our-guides:disabled:hover {
  transform: none; 
  background: linear-gradient(90deg, #cccccc 0%, #999999 100%);
  box-shadow: none;
  }
  
  .custom-border{
  border-radius: 62px;
  border: 1px solid var(--gradient, #1E93FD);
  }
  
  @media (max-width: 767px) {
  
  }
  
  
  
  .no-arrows::-webkit-inner-spin-button,
  .no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  }
  
  .no-arrows {
  -moz-appearance: textfield;
  }
  
  .button-selector {
  background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
  color: white;
  padding: 0.5rem 1rem;
  font-size: 17px; 
  }
  
  
  .flex-input-container {
  display: flex;
  align-items: center;
  border: 1px solid #1E93FD;
  border-radius: 10px;
  overflow: hidden;
  }
  
  
  .flex-input-container input {
  width: 50px; 
  text-align: center;
  border-left: 1px solid #d1d5db;
  border-right: 1px solid #d1d5db;
  outline: none;
  font-size: 14px;
  padding: 0.5rem;
  }
  
  
  .text-gender{
  background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3153C7 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; 
  }
  
  .button-selector:disabled {
  background: var(--gradient, linear-gradient(90deg, #cccccc 0%, #999999 100%));
  cursor: not-allowed;
  }
  
  .number-blue {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-right: 15px;
  background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  }
  
  .button-continu {
    background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
    color: #FFF;
    box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
    transition: background 0.3s ease, box-shadow 0.3s ease;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
  
  .button-continu:hover {
    background: linear-gradient(90deg, #3154C8 0%, #3154C8 100%);
    box-shadow: 0 6px 14px rgba(30, 147, 253, 0.4);
  }
  
  .button-continu:disabled {
  background: linear-gradient(90deg, #B0B0B0 0%, #8C8C8C 100%);
  box-shadow: none;
  cursor: not-allowed;
  color: #E0E0E0;
  }

  .quantity-display{
    border-radius: 5px;
    background: #1E93FD;
    color: #FFF;
    font-family: Montserrat;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
  }

  .text-profil{
    color: #000;
    font-family: Montserrat;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; 
  }

  .text-profil-white{
    color: #fff;
    font-family: Montserrat;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; 
  }

  .text-sm-payment{
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 127.5%;
  }

  .TotalMonthsPerProfiles{
    border-radius: 4px;
    background: #083879;
    display: flex;
    padding: 4px 10px;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
   }

   .priceTotalMonths{
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
   }

   .priceTotalMonths-white{
    color: #fff;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
   }

    .priceTotalMonthsPerProfiles{
        font-weight: 700;
    }

    .responsive-svg{
        width: 2vw;
    }

    .total-panier{
        color: #000;
        font-family: Montserrat;
        font-size: 25px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }

    .total-profil{
        color: #000;
        font-family: Montserrat;
        font-size: 25px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; 
    }

    .reconfirm-link {
      color: #3154C8;
      text-decoration: underline;
      font-weight: 500;
    }

    .replace-button {
        margin-right: 10px;
        border: 1px solid #FA5D72;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        text-transform: uppercase; 
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        color: transparent;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
      }


      .replace-button:hover {
        background: var(--gradient, linear-gradient(90deg, #FA5D72 0%, #c83131 100%));
        color: #ffffff; 
      }

      .replace-button:hover span {
        color: #ffffff !important; 
        -webkit-text-fill-color: #ffffff !important;
      }

      .replace-button:hover i {
        color: #ffffff; 
        -webkit-text-fill-color: #ffffff;
      }

      .replace-button i, .replace-button span {
        background: var(--gradient, linear-gradient(90deg, #FA5D72 0%, #c83131 100%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; 
        color: transparent;
      }
  
  </style>